var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeedBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.72 611.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: -.07em;\n      }\n\n      .cls-2 {\n        font-family: ArialMT, Arial;\n        font-size: 12px;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #27aae1;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(9.3 608.08)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.91,
    y: 603.31,
    width: 17.8,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 600.31,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 597.31,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 594.3,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 591.3,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.09,
    y: 588.29,
    width: 13.63,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 585.3,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 582.3,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 579.29,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 576.29,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.91,
    y: 573.29,
    width: 17.8,
    height: 1.17
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(9.3 577.72)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 570.29,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 567.29,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 564.28,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.09,
    y: 558.26,
    width: 13.63,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 555.28,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 552.28,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 549.26,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 546.26,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.91,
    y: 543.26,
    width: 17.8,
    height: 1.17
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(9.39 547.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 561.28,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 540.26,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 537.26,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 534.25,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 531.25,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.09,
    y: 528.24,
    width: 13.63,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 525.25,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 522.25,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 519.24,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 516.24,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.91,
    y: 513.24,
    width: 17.8,
    height: 1.17
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(9.43 517.67)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 510.24,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 507.24,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 504.23,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.09,
    y: 498.22,
    width: 13.63,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 495.23,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 492.23,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 489.22,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 486.22,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.91,
    y: 483.22,
    width: 17.8,
    height: 1.17
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(9.51 487.65)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 501.23,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 480.22,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 477.22,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 474.21,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 471.21,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.09,
    y: 468.2,
    width: 13.63,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 465.21,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 462.21,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 459.2,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 456.2,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.91,
    y: 453.2,
    width: 17.8,
    height: 1.17
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(9.51 457.63)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "5")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 450.2,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 447.2,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 444.19,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.09,
    y: 438.18,
    width: 13.63,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 435.19,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 432.19,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 429.18,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 426.18,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.91,
    y: 423.18,
    width: 17.8,
    height: 1.17
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(9.6 427.61)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 441.19,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 420.18,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 417.18,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 414.17,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 411.17,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.09,
    y: 408.16,
    width: 13.63,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 405.17,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 402.17,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 399.16,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 396.16,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.91,
    y: 393.16,
    width: 17.8,
    height: 1.17
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(9.64 397.59)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "7")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 390.16,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 387.16,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 384.14,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.09,
    y: 378.13,
    width: 13.63,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 375.14,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 372.14,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 369.13,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 366.13,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.91,
    y: 363.13,
    width: 17.8,
    height: 1.17
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(9.72 367.57)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "8")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 381.14,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 360.13,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 357.12,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 354.12,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.09,
    y: 351.11,
    width: 13.63,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 348.12,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 345.12,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 342.11,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 339.11,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(9.72 340.54)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "9")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 333.11,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 330.11,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 327.1,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.09,
    y: 321.09,
    width: 13.63,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 318.1,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 315.1,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 312.09,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 309.09,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3.13 310.52)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "10")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 324.1,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 303.09,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 300.09,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 297.08,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 294.08,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.09,
    y: 291.07,
    width: 13.63,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 288.08,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 285.08,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 282.07,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 279.07,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(4.07 280.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 0,
    y: 0
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 5.78,
    y: 0
  }, "1")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 273.07,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 270.07,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 267.06,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.09,
    y: 261.05,
    width: 13.63,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 258.06,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 255.06,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 252.05,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 249.05,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3.26 250.48)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "12")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 264.06,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 243.05,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 240.05,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 237.04,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 234.04,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.09,
    y: 231.03,
    width: 13.63,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 228.04,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 225.04,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 222.03,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 219.03,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3.26 220.46)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "13")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.91,
    y: 336.11,
    width: 17.8,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.91,
    y: 306.09,
    width: 17.8,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.91,
    y: 276.07,
    width: 17.8,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.91,
    y: 246.05,
    width: 17.8,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.91,
    y: 216.03,
    width: 17.8,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 213.03,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 210.03,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 207.01,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 204.01,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.09,
    y: 201,
    width: 13.63,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 198.01,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 195.01,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 192,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 189,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3.26 190.44)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "14")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.91,
    y: 186,
    width: 17.8,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 183,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 180,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 176.99,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 173.99,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.09,
    y: 170.98,
    width: 13.63,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 167.99,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 164.99,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 161.98,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 158.98,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3 160.41)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "15")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.91,
    y: 155.98,
    width: 17.8,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 152.98,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 149.98,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 146.97,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 143.97,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.09,
    y: 140.96,
    width: 13.63,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 137.97,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 134.97,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 131.96,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 128.96,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3 130.39)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "16")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.91,
    y: 125.96,
    width: 17.8,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 122.96,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 119.96,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 116.95,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 113.95,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.09,
    y: 110.94,
    width: 13.63,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 107.95,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 104.95,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 101.94,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 98.94,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3 100.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "17")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.91,
    y: 95.94,
    width: 17.8,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 92.94,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 89.94,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 86.93,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 83.93,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.09,
    y: 80.92,
    width: 13.63,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 77.93,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 74.93,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 71.92,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 68.92,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(2.74 70.35)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "18")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.91,
    y: 65.92,
    width: 17.8,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 62.92,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 59.92,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 56.91,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 53.91,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.09,
    y: 50.89,
    width: 13.63,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 47.91,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 44.91,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 41.89,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 38.89,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(2.74 40.33)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "19")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.91,
    y: 35.89,
    width: 17.8,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 32.89,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 29.89,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 26.88,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 23.88,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.09,
    y: 20.87,
    width: 13.63,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 17.88,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 14.88,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 11.87,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.55,
    y: 8.87,
    width: 10.17,
    height: 1.17
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(2.74 10.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "20")), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 17.91,
    y: 5.87,
    width: 17.8,
    height: 1.17
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedBar);
export default __webpack_public_path__ + "static/media/speed-bar.8172fd40ec5abc3b7c9cbcdc0fb12a18.svg";
export { ForwardRef as ReactComponent };